import MContainer from './MContainer.vue';

MContainer.install = (app) => {
  app.component('MContainer', MContainer);
};

export { MContainer };
